import { apiPathFunc } from "@api/util/apiPathFunc";
import type { IExtractParams } from "@/routes";

const pathBase = `/users/me/delete-requests/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const deleteRequests = {
  post: apiPathFunc(pathBase),
};
